module.exports = __webpack_public_path__ + "img/partner5.0e01dbf7.png";